import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, PageHeaderItem, dineroDisabledMask } from "../../../Components/Items";
import dayjs from "dayjs";

class Devoluciones extends Component {
  state = {
    todasDevoluciones: [],
    loading: false,
  }
  componentDidMount() {
    this.consultarDevoluciones();
  }

  consultarDevoluciones() {
    this.setState({loading: true})
    axios
    .post(
      "devoluciones/selectTodasDevoluciones",
      { empresaId: this.props.empresaId },
      {
        headers: this.props.headersToken,
      }
    )
    .then((res) => {
      this.setState({loading: false})
      if (res.data.success === 2) {
          this.setState({
            todasDevoluciones: res.data.devoluciones.map((value) => {

              let formaDePago
              if(value.formaDePago === 3){
                formaDePago = 'Transferencia'
              }else if(value.formaDePago === 2){
                formaDePago = 'Efectivo'
              }else{
                formaDePago = 'Tarjeta'
              }

              return {
                ...value,
                metodoPago: value.metodoPago === 1 ? 'Conekta' : 'Fisico',
                formaDePago: formaDePago,
                accion: { _id: value._id, estado: value.estado },
              };
            }),
          });
      }
    });
  }

  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
      },
      {
        title: "Monto",
        dataIndex: "cantidad",
        key: "cantidad",
        sorter: (a, b) => {
          if (a.cantidad < b.cantidad) {
            return -1;
          }
          if (a.cantidad > b.cantidad) {
            return 1;
          }
          return 0;
        },
        render: (value) => dineroDisabledMask(value),
        buscar: "cantidad",
      },
      {
        title: "Fecha",
        dataIndex: "fechaDevolucion",
        key: "fechaDevolucion",
        sorter: (a, b) => {
          if (a.fechaDevolucion < b.fechaDevolucion) {
            return -1;
          }
          if (a.fechaDevolucion > b.fechaDevolucion) {
            return 1;
          }
          return 0;
        },
        render: (value) => dayjs(value).format('DD/MM/YYYY'),
        buscar: "fechaDevolucion",
      },
      {
        title: "Metodo Pago",
        dataIndex: "metodoPago",
        key: "metodoPago",
        sorter: (a, b) => {
          if (a.metodoPago < b.metodoPago) {
            return -1;
          }
          if (a.metodoPago > b.metodoPago) {
            return 1;
          }
          return 0;
        },
        render: (value) => value === 1 ? 'Conekta' : 'Fisico',
        buscar: "metodoPago",
        responsive: ['lg'],
      },
      {
        title: "Forma Pago",
        dataIndex: "formaDePago",
        key: "formaDePago",
        sorter: (a, b) => {
          if (a.formaDePago < b.formaDePago) {
            return -1;
          }
          if (a.formaDePago > b.formaDePago) {
            return 1;
          }
          return 0;
        },
        render: (value) => {
            if(value === 3){
                return 'Transferencia'
            }else if(value === 2){
                return 'Efectivo'
            }else{
                return 'Tarjeta'
            }
        },
        buscar: "formaDePago",
        responsive: ['lg'],
      },

    ];
    return (
      <>
        <PageHeaderItem
          title="Devoluciones"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <TableItem
        loading={this.state.loading}
          size="small"
          dataSource={this.state.todasDevoluciones}
          columns={columns}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
  };
};

export default connect(mapStateToProps)(Devoluciones);